@app.filter "priceConversion", ->
  (text) ->
    parseFloat(text)
